import { ChartBlock, JobsTooltip, Period } from '@/ui-kit'
import { Trans, useLingui } from '@lingui/react/macro'
import { useState } from 'react'
import { Worker } from '../api/models'
import { useFetchWorkerJobs } from '../api/useFetchWorkerJobs'
import { useFetchWorkerJobsPoints } from '../api/useFetchWorkerJobsPoints'
import { useFetchWorkerUptime } from '../api/useFetchWorkerUptime'
import { useFetchWorkerUptimePoints } from '../api/useFetchWorkerUptimePoints'
import { getDeviceDescription } from '../utils/getDeviceDescription'

export function DeviceStats({ worker }: { worker: Worker }): React.JSX.Element {
  const { t } = useLingui()
  const [pointsPeriod, setPointsPeriod] = useState<Period>('day')
  const [jobsPeriod, setJobsPeriod] = useState<Period>('day')
  const [uptimePeriod, setUptimePeriod] = useState<Period>('day')
  const { data: points } = useFetchWorkerJobsPoints(worker.id, pointsPeriod)
  const { data: uptimePoints } = useFetchWorkerUptimePoints(worker.id, pointsPeriod)

  const { data: nonRestrictedJobs } = useFetchWorkerJobs(worker.id, jobsPeriod)

  const { data: uptime } = useFetchWorkerUptime(worker.id, uptimePeriod)
  const targetDate = { title: t`Device was activated`, date: worker.createdAt }
  const deviceLabel = getDeviceDescription(worker?.metadata?.userAgent, true)
  const noDataText = (
    <>
      <Trans>
        No data available for <span className="max-mobile:block">&quot;{deviceLabel}&quot; yet</span>
      </Trans>
    </>
  )

  return (
    <div className="max-tablet:mx-0 mt-4 flex flex-1 flex-col gap-4">
      <ChartBlock
        title={{ plural: t`DataHive Points`, singular: t`DataHive Point` }}
        data={points}
        data3={uptimePoints}
        period={pointsPeriod}
        onPeriodChange={setPointsPeriod}
        noDataText={noDataText}
        targetDate={targetDate}
        isStackedBars
      />
      <ChartBlock
        title={{ plural: t`Jobs`, singular: t`Job` }}
        data={nonRestrictedJobs}
        period={jobsPeriod}
        onPeriodChange={setJobsPeriod}
        noDataText={noDataText}
        targetDate={targetDate}
        tooltipNode={JobsTooltip as any}
      />
      <ChartBlock
        title={{ plural: t`Uptime`, singular: t`Uptime` }}
        data={uptime}
        period={uptimePeriod}
        onPeriodChange={setUptimePeriod}
        noDataText={noDataText}
        targetDate={targetDate}
        isPercents
      />
    </div>
  )
}
